<div #btnContainer class="btn-wrapper" [ngStyle]="{'margin-bottom': mb, 'margin-top': mt}">
    <div class="btn-ball"></div>
    <button class="primary-btn" [ngClass]="{'gradient' : gradient, 'review' : variant === 'review'}" [disabled]="disabled">
        @if (isLoading) { 
            <app-spinner variant="btn-spinner" [ngClass]="{'gradient' : gradient}" size="20px"></app-spinner>
        } @else {
            <ng-content></ng-content>
        }
    </button>
</div>